export default __webpack_public_path__ + "static/saas-platform-compliance-cb2e18e58ee382be949fd5736ee76547.jpg";